<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-button variant="warning" @click="close">Close</b-button>
        </div>
      </div>

      <div slot="footer" style="text-align: center">
        <b-button variant="warning" class="mr-1" @click="close()">
          <i class="fa fa-close"></i> Close Form
        </b-button>
        <b-button variant="success" class="mr-1" @click="save">
          <i class="fa fa-floppy-o mr-1"></i> Save</b-button
        >
      </div>

      <b-card>
        <b-card-title>
          <u>Collector Information</u>
        </b-card-title>
        <b-row>
          <b-col md="8">
            <b-form-group
              label-cols="6"
              label-cols-lg="4"
              label="Collector NIK"
            >
              <b-input-group>
                <b-form-input
                  v-model="model.crewnik"
                  disabled
                  :state="!this.$v.model.crewkey.$error"
                ></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuCollectorShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group label-cols="6" label-cols-lg="4" label="Full Name">
              <b-input-group>
                <b-form-input v-model="model.crewname" disabled></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group label-cols="6" label-cols-lg="4" label="Phone">
              <b-input-group>
                <b-form-input v-model="model.crewhp" disabled></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group label-cols="6" label-cols-lg="4" label="Email">
              <b-input-group>
                <b-form-input v-model="model.crewmail" disabled></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group label-cols="6" label-cols-lg="4" label="Job Title">
              <b-input-group>
                <b-form-input v-model="model.jabatan" disabled></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group label-cols="6" label-cols-lg="4" label="Position">
              <b-input-group>
                <b-form-input v-model="model.golongan" disabled></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group label-cols="6" label-cols-lg="4" label="Departement">
              <b-input-group>
                <b-form-input
                  v-model="model.departemen"
                  disabled
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card>
        <b-card-title>
          <u>Debitur Information</u>
        </b-card-title>

        <b-row>
          <b-col>
            <b-form-group label-cols="6" label-cols-lg="4" label="Customer ID">
              <b-input-group>
                <b-form-input
                  v-model="model.customerID"
                  :state="!this.$v.model.customerID.$error"
                  disabled
                ></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuBorrowerShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label-cols="6"
              label-cols-lg="4"
              label="Debtor Fullname"
            >
              <b-form-input
                v-model="model.debtorFullName"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group label-cols="4" label-cols-lg="2" label="Gender Code">
          <b-form-radio-group v-model="model.genderCode" disabled>
            <b-form-radio value="L">Laki-laki</b-form-radio>
            <b-form-radio value="P">Perempuan</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <!-- <b-row>
          <b-col>
            <b-form-group label-cols="6" label-cols-lg="4" label="Id Type">
              <b-form-input disabled></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label-cols="6" label-cols-lg="4" label="Id Number">
              <b-form-input disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row> -->
        <b-row>
          <b-col
            ><b-form-group
              label-cols="4"
              label-cols-lg="4"
              label="Place Of Birth"
            >
              <b-form-input
                v-model="model.placeOfBirth"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label-cols="4"
              label-cols-lg="4"
              label="Date Of Birth"
            >
              <b-form-input
                v-model="model.dateOfBirth"
                disabled
              ></b-form-input> </b-form-group
          ></b-col>
        </b-row>
        <b-row>
          <b-col
            ><b-form-group
              label-cols="4"
              label-cols-lg="4"
              label="Mobile Phone Number"
            >
              <b-form-input
                v-model="model.mobilePhoneNumber"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label-cols="4"
              label-cols-lg="4"
              label="Lease Phone Number"
            >
              <b-form-input disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group label-cols="4" label-cols-lg="2" label="Email">
          <b-form-input disabled></b-form-input>
        </b-form-group>
        <b-form-group label-cols="4" label-cols-lg="2" label="Address">
          <b-form-textarea v-model="model.address" disabled></b-form-textarea>
        </b-form-group>
        <b-row>
          <b-col>
            <b-form-group label-cols="4" label-cols-lg="4" label="Country">
              <b-form-input
                v-model="model.country"
                disabled
              ></b-form-input> </b-form-group
          ></b-col>
          <b-col
            ><b-form-group label-cols="4" label-cols-lg="4" label="Province">
              <b-form-input
                v-model="model.nama_province"
                disabled
              ></b-form-input> </b-form-group
          ></b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label-cols="4" label-cols-lg="4" label="City">
              <b-form-input
                v-model="model.nama_city"
                disabled
              ></b-form-input> </b-form-group
          ></b-col>
          <b-col
            ><b-form-group label-cols="4" label-cols-lg="4" label="District">
              <b-form-input
                v-model="model.nama_district"
                disabled
              ></b-form-input> </b-form-group
          ></b-col>
        </b-row>

        <b-row>
          <b-col
            ><b-form-group
              label-cols="4"
              label-cols-lg="4"
              label="Sub District"
            >
              <b-form-input
                v-model="model.nama_subDistrict"
                disabled
              ></b-form-input> </b-form-group
          ></b-col>
          <b-col
            ><b-form-group label-cols="4" label-cols-lg="4" label="Postal Code">
              <b-form-input disabled></b-form-input> </b-form-group
          ></b-col>
        </b-row>
      </b-card>
      <b-card>
        <b-card-title>
          <u>Loan Information</u>
        </b-card-title>
        <b-row>
          <b-col md="8">
            <b-form-group label-cols="6" label-cols-lg="4" label="Loan Id">
              <b-input-group>
                <b-form-input
                  v-model="model.partnerLoanApplicationNumber"
                  disabled
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group label-cols="6" label-cols-lg="4" label="Due Date">
              <b-input-group>
                <b-form-input
                  v-model="model.installmentEndDateFormated"
                  disabled
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group
              label-cols="6"
              label-cols-lg="4"
              label="Disbursement Amt."
            >
              <b-input-group>
                <my-number
                  v-model="model.disbursement_amount"
                  :precision="2"
                  class="bg-warning text-dark text-right"
                  disabled
                ></my-number>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group
              label-cols="6"
              label-cols-lg="4"
              label="Repayment Amt."
            >
              <b-input-group>
                <my-number
                  v-model="model.principal_repayment"
                  :precision="2"
                  class="bg-warning text-dark text-right"
                  disabled
                ></my-number>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group label-cols="6" label-cols-lg="4" label="Principal OS">
              <b-input-group>
                <my-number
                  v-model="model.principal_outstanding"
                  :precision="2"
                  class="bg-warning text-dark text-right"
                  disabled
                ></my-number>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="8">
            <b-form-group
              label-cols="6"
              label-cols-lg="4"
              label="Day Past Due (DPD)"
            >
              <b-input-group>
                <my-number
                  v-model="model.dpd"
                  :precision="0"
                  class="bg-warning text-dark text-right"
                  disabled
                ></my-number>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

      <b-card>
        <b-card-title>
          <u>Assignment Period</u>
        </b-card-title>
        <b-form-group label-cols="4" label-cols-lg="4" label="Start Date">
          <b-form-input
            v-model="model.collect_next_date"
            type="date"
          ></b-form-input>
        </b-form-group>
        <b-form-group label-cols="4" label-cols-lg="4" label="Due Date">
          <b-form-input
            v-model="model.collect_next_date"
            type="date"
          ></b-form-input>
        </b-form-group>
        <b-form-group label-cols="4" label-cols-lg="4" label="Note">
          <b-form-textarea
            v-model="model.note"
            :state="!this.$v.model.note.$error"
            rows="3"
            max-rows="5"
          ></b-form-textarea>
        </b-form-group>
      </b-card>
    </b-card>
    <b-modal
      v-model="lkuBorrowerShow"
      size="lg"
      :hide-footer="true"
      title="List of Borrower"
      :centered="true"
    >
      <lku-borrower @click="onSelectBorrower"></lku-borrower>
    </b-modal>

    <b-modal
      v-model="lkuCollectorShow"
      size="lg"
      :hide-footer="true"
      title="List of Collector"
      :centered="true"
    >
      <lku-collector @click="onSelectCollector"></lku-collector>
    </b-modal>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>
              
  <script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import toastr from "mini-toastr";
toastr.init();

import myNumber from "../../components/my-number.vue";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import crud from "../../apis/crud";
import collection from "../../apis/collection";
import lkuBorrower from "../../views/lookup/lkuBorrower.vue";
import lkuCollector from "../../views/lookup/lkuCrewCollectorLazzy.vue";

export default {
  components: { Loading, lkuBorrower, lkuCollector, myNumber },
  mixins: [validationMixin],
  validations: {
    model: {
      crewkey: { required },
      customerID: { required },
      note: { required },
    },
  },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      isLoading: false,
      dataLoan: [],
      fields: [
        {
          key: "index",
          label: "#",
          sortable: true,
        },
        {
          key: "partnerLoanApplicationNumber",
          label: "Loan Id",
          sortable: true,
        },
        {
          key: "installmentEndDate",
          label: "Due Date",
          sortable: true,
          thClass: "text-center",
          thStyle: "min-width:100px",
        },
        {
          key: "disbursement_date_first",
          label: "Disbursement First",
          sortable: true,
        },
        {
          key: "disbursement_amount",
          label: "Disbursement Amount",
          sortable: true,
        },

        {
          key: "repayment_principal_date",
          label: "Repayment Principal Date",
          sortable: true,
        },
        {
          key: "principal_repayment",
          label: "Principal Repayment",
          sortable: true,
        },
        // {
        //   key: "late_fee",
        //   label: "Late Fee",
        //   sortable: true,
        // },
        // {
        //   key: "service_Charge",
        //   label: "Service Charge",
        //   sortable: true,
        // },
        {
          key: "interest_repaid",
          label: "Interest Repaid",
          sortable: true,
        },
        {
          key: "principal_outstanding",
          label: "Principal OS.",
          sortable: true,
        },
        {
          key: "interest_estimate",
          label: "Interest Estimate",
          sortable: true,
        },
        {
          key: "dpd",
          label: "DPD",
          sortable: true,
        },
      ],
      dataDisbursement: [],
      fieldsDisbursement: [
        {
          key: "index",
          label: "#",
          sortable: true,
        },
        {
          key: "loan_id",
          label: "Loan ID",
          sortable: true,
        },
        {
          key: "disbursed_date",
          label: "Disbursed Date",
          sortable: true,
        },
        {
          key: "loan_amount",
          label: "Loan Amount",
          sortable: true,
        },
      ],
      dataRepayment: [],
      fieldsRepayment: [
        {
          key: "index",
          label: "#",
          sortable: true,
        },
        {
          key: "repayment_date",
          label: "Repayment Date",
          sortable: true,
        },
        {
          key: "total_repayment",
          label: "Total Repayment",
          sortable: true,
        },
        {
          key: "principal",
          label: "Principal",
          sortable: true,
        },
        {
          key: "interest_repaid",
          label: "Interest Repaid",
          sortable: true,
        },
      ],
      model: {
        crewkey: "",
        crewnik: "",
        crewname: "",
        crewhp: "",
        crewmail: "",
        jabatan: "",
        departemen: "",
        borrowerKey: "",
        customerID: "",
        debtorFullName: "",
        genderCode: "",
        estimatedYearlyGrossIncome: "",
        mobilePhoneNumber: "",
        placeOfBirth: "",
        dateOfBirth: "",
        professionCode: "",
        employerName: "",
        employerIndustryCode: "",
        motherMaidenName: "",
        maritalStatus: "",
        monthlyIncome: "",
        citizen: "",
        religion: "",
        address: "",
        country: "",
        province: "",
        city: "",
        district: "",
        subDistrict: "",
        partnerLoanApplicationNumber: "",
        installmentEndDate: "",
        installmentEndDateFormated: "",
        disbursement_amount: 0,
        principal_repayment: 0,
        principal_outstanding: 0,
        dpd: 0,
        note: "",
      },
      lkuBorrowerShow: false,
      lkuCollectorShow: false,
      typeActivityOpt: [
        { value: null, text: "Please select an option" },
        { value: "call", text: "Call" },
        { value: "visit", text: "Visit" },
        { value: "email", text: "Email" },
      ],
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      //   console.log(this.$v.model);
      return this.$v.model.$invalid;
    },
  },
  async created() {
    if (this.$route.params.borrowerKey) {
      this.getData(this.$route.params.borrowerKey);
    }
  },
  methods: {
    onSelectBorrower(selected) {
      try {
        this.isLoading = true;
        this.lkuBorrowerShow = !this.lkuBorrowerShow;
        const { customerID, debtorFullName } = selected;
        if (!customerID) return;

        this.model.customerID = customerID;
        this.model.debtorFullName = debtorFullName;
        this.getData(selected.borrowerKey, customerID);
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);

      }
    },
    onSelectCollector({ items, selected }) {
      try {
        this.isLoading = true;
        const keys = [
          "crewkey",
          "crewnik",
          "crewname",
          "crewhp",
          "crewmail",
          "jabatan",
          "golongan",
          "departemen",
        ];

        for (const key of keys) {
          this.model[key] = selected[key];
        }
        this.lkuCollectorShow = !this.lkuCollectorShow;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
      }
    },
    async getData(borrowerKey, customerID) {
      if (borrowerKey) {
        toastr.info("Loading Agreement View, Please Wait...");
        this.isLoading = true;
        this.isBusy = true;
        try {
          this.dataLoan = [];
          this.dataDisbursement = [];
          this.dataRepayment = [];
          const data = await crud.detail({
            tablename: "vwborrower",
            key: borrowerKey,
          });
          const row = data;
          for (var key in row) {
            this.model[key] = row[key];
          }
          this.model.dateOfBirth = moment(this.model.dateOfBirth).format(
            "DD MMM YYYY"
          );

          if (customerID) {
            this.dataLoan = await crud.list({
              tablename: "loanapplication",
              customQuery: `customerID=${encodeURIComponent(customerID)}`,
            });

            let loan_OS = this.dataLoan.find(
              (x) => x.principal_outstanding > 0
            );
            if (loan_OS) {
              const keysLoan = [
                "partnerLoanApplicationNumber",
                "installmentEndDate",
                "installmentEndDateFormated",
                "disbursement_amount",
                "principal_repayment",
                "principal_outstanding",
                "dpd",
              ];
              for (const iterator of keysLoan) {
                this.model[iterator] = loan_OS[iterator];
              }
              this.model.installmentEndDateFormated = moment(
                this.model.installmentEndDate
              ).format("MMM DD YYYY");
            }

            this.dataDisbursement = await crud.list({
              tablename: "disbursementcrud",
              customQuery: `customerID=${customerID}`,
            });

            this.dataRepayment = await crud.list({
              tablename: "repaymentcrud",
              customQuery: `customerID=${encodeURIComponent(customerID)}`,
            });
          }

          this.isBusy = false;
          this.isLoading = false;
          this.$forceUpdate();
          toastr.clear;
        } catch (error) {
          this.isBusy = false;
          this.isLoading = false;
          console.log("error : ", error);
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async save() {
      try {
        if (this.invalidModel) {
          toastr.error("Please fill the form correctly.", "Error Info");
        } else {
          this.isLoading = true;
          await collection.saveAssignment(this.model);
          this.isLoading = false;
          toastr.success(`Success save data.`, "Save", 10000);
          // this.close();
        }
      } catch (error) {
        this.isLoading = false;
        console.log("error >>", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
      }
    },
    close() {
      // router.push({ name: "collection.activity" });
      router.go(-1);
    },
  },
};
</script>